
import React from 'react';
import { Loader, Dimmer } from 'semantic-ui-react';
import { compose, branch, renderComponent, mapProps, withState } from 'recompose';
import { withFormItems } from '../items/forms-items.helper';

export const withItemSelection = compose(
	withFormItems,
	branch(
		({ ready }) => !ready,
		renderComponent(() => <Dimmer active><Loader content='Loading' /></Dimmer>)
	),
	mapProps(({ items, match }) => ({
		item: items.find(item => item.ASM_Item_ID.toString() === match.params.item_id)
	})),
);

export default {
	withItemSelection,
};
